import {useState, useEffect} from 'react'

import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import AccordionGroup from 'components/Accordion/AccordionGroup'

import MDButton from "components/MDButton";
import Card from "@mui/material/Card";
import { timeConverter } from 'timeConverter/timeConverter';
import Icon from "@mui/material/Icon"

import DataTable from "examples/Tables/DataTable";
import CircleIcon from '@mui/icons-material/Circle';

/* eslint-disable react/prop-types */
export default function ModalAvatarsData() {


    return (
        <>
            <Grid container spacing={1} width={"32rem"} height={"35rem"}>
                <Grid item xs={12} >
                    <MDTypography component="div" variant="button" color="text" fontWeight="medium" mt={1}>
                        This is a pilot.
                        <MDTypography component="div" variant="button" color="text" fontWeight="regular" mt={1}>
                        In first official release, by clicking on "Avatar Detail" button you will be able to see all avatar data collected in relation with tou shops/products.
                        </MDTypography>
                        <MDTypography component="div" variant="button" color="text" fontWeight="regular" mt={1}>
                            <CircleIcon style={{width:"0.5rem"}}/> All data related to your surveys and all avatar provided answers
                        </MDTypography>
                        <MDTypography component="div" variant="button" color="text" fontWeight="regular" mt={1}>
                            <CircleIcon style={{width:"0.5rem"}} /> All avatar transactions in relation to your shops and products
                        </MDTypography>
                        <MDTypography component="div" variant="button" color="text" fontWeight="regular" mt={1}>
                            <CircleIcon style={{width:"0.5rem"}} /> All discounts negotiated between avatar and your shops and all associated offers
                        </MDTypography>
                        <MDTypography component="div" variant="button" color="text" fontWeight="regular" mt={1}>
                            <CircleIcon style={{width:"0.5rem"}} /> Avatar personal detail
                        </MDTypography>
                        <MDTypography component="div" variant="button" color="text" fontWeight="regular" mt={1}>
                            <CircleIcon style={{width:"0.5rem"}} /> General avatar preferences, behavior suggestion, product preferences and suggested campaigns 
                        </MDTypography>
                    </MDTypography>
                </Grid>
            </Grid>
        </>


    );
}